export const dashboardWidgets = {
  upcoming: {
    title: "Próximas chegadas",
    empty: "Nenhum evento próximo",
    createBooking: "Criar reserva",
  },
  lastActivity: {
    title: "Atividade recente",
  },
  portals: {
    title: "Canais de reserva sincronizados",
    connectedSuccess: "Conectado com sucesso",
    unknownChannel: "Desconhecido",
    connectNewChannel: "Conectar um novo canal",
    empty: "Você não tem canais sincronizados",
    connectChannel: "Conectar um canal",
    loadError: "Não foi possível carregar os portais",
    errorTitle: "Erro",
  },
};
